import type { Cart } from '@getjust/gateway';

export function hasUnavailableProducts(cart?: Cart): boolean {
  return cart?.lineItems?.some?.((lineItem) => !lineItem?.isAvailable) ?? false;
}
